var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bannerImagem"}},[_c('img',{attrs:{"src":_vm.$props.image}})])
}
var staticRenderFns = []

export { render, staticRenderFns }